import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  assetId: belongsTo('asset', { inverse: null }),
  categoryId: belongsTo('category', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  linkId: belongsTo('link', { inverse: null }),
});
